// extracted by mini-css-extract-plugin
module.exports = {"option":"Operator_option__1VD0h"};